import api from './api'

export const seoService = {
  async getPublic() {
    const response = await api.get('/seo')
    return response.data
  },

  /**
   * SUPERADMIN
   * @param {object} payload - mismos campos que devuelve la configuración pública
   */
  async updateAdmin(payload) {
    const response = await api.put('/admin/seo', payload)
    return response.data
  },
}
